export default function Footer() {
  return (
    <footer className="mt-24 border-t border-labor-border bg-labor-skyBg">      <div className="tricolor-bar" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 grid gap-10 md:grid-cols-3">
        <div>
          <div className="font-display text-2xl font-bold text-labor-olive">CAF Patronato Labor</div>
          <p className="text-labor-muted text-sm mt-2 leading-relaxed">Assistenza fiscale, previdenziale e legale a Bitonto. Qualità, riservatezza, un rapporto umano con ogni assistito.</p>
          <div className="flex items-center gap-1 mt-4">
            <span className="w-4 h-3 bg-labor-italianGreen"></span>
            <span className="w-4 h-3 bg-white border border-labor-border"></span>
            <span className="w-4 h-3 bg-labor-italianRed"></span>
            <span className="text-xs text-labor-muted ml-2">Fatto in Italia</span>
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-labor-muted mb-3">Contatti</div>
          <ul className="text-sm space-y-1">
            <li>Via Zuavo n. 12 · 70032 Bitonto (BA)</li>
            <li><a href="tel:+393791466566" className="hover:text-labor-olive">📞 379 146 6566 · solo urgenze</a></li>
            <li className="text-labor-muted text-xs pt-1">Per info generali usa <strong>Labor AI</strong> o prenota online</li>
            <li><a href="mailto:caflaborvitobitonto@gmail.com" className="hover:text-labor-olive break-all">caflaborvitobitonto@gmail.com</a></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-labor-muted mb-3">Orari appuntamenti</div>
          <ul className="text-sm space-y-1 text-labor-ink">
            <li>Lun: 9:00-12:00 · 16:00-18:30</li>
            <li>Mar: 16:00-18:30</li>
            <li>Mer: 9:00-12:00 · Avv. 16:30-18:30</li>
            <li>Gio: 16:00-18:30</li>
            <li>Ven: 16:00-18:30</li>
            <li className="text-labor-muted">Sab-Dom: chiuso</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-labor-border">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 text-xs text-labor-muted flex flex-col sm:flex-row justify-between gap-2">
          <span data-testid="footer-copyright">Copyright © {new Date().getFullYear()} Caf Labor | Powered by DC Consulting</span>
          <span className="flex flex-wrap gap-3 items-center">
            <a href="/privacy-policy" data-testid="footer-privacy-link" className="hover:text-labor-olive underline">Privacy Policy</a>
            <span>·</span>
            <a href="/termini-di-servizio" data-testid="footer-terms-link" className="hover:text-labor-olive underline">Termini</a>
            <span>·</span>
            <span>Titolare: Vito · con Marianna</span>
          </span>
        </div>
      </div>
    </footer>
  );
}
